"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-OmniSearch',
    icon: 'c-OmniSearch__icon',
    input: 'c-OmniSearch__input',
    clear: 'c-OmniSearch__clear'
};
exports.Style = {
    [exports.CSS.container]: {
        'background-color': theme_1.DefaultTheme.background.mediumGrey,
        padding: `0 ${theme_1.DefaultTheme.space(2)}`,
        display: 'flex',
        'align-items': 'center',
        color: theme_1.DefaultTheme.font.color.white
    },
    [exports.CSS.input]: {
        flex: '1',
        border: 'none',
        outline: 'none',
        'background-color': 'transparent',
        'font-family': theme_1.DefaultTheme.font.family,
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.font.color.white,
        'margin-left': theme_1.DefaultTheme.space(4)
    },
    [`${exports.CSS.input}::placeholder`]: {
        opacity: '0.6',
        color: theme_1.DefaultTheme.font.color.white,
        transition: 'opacity 0.2s ease'
    },
    [exports.CSS.clear]: {
        color: theme_1.DefaultTheme.font.color.white
    },
    [`${exports.CSS.input}:focus::placeholder`]: {
        opacity: '0.8',
        color: theme_1.DefaultTheme.font.color.white
    },
    [exports.CSS.icon]: {
        'pointer-events': 'none'
    }
};
//# sourceMappingURL=omni.search.style.js.map